import React from 'react'
import { useStepsState } from '@context/StepsContext'
import useStyles from './StatusBarMobile.styles'
import { getStepNameFromNumber } from './helper'
import { useTranslation } from 'react-i18next'
import { useIsCityVariant } from '@hooks/useIsCityVariant'
import { useIsAllClinicsVariant } from '@hooks/useIsAllClinicsVariant'

// generated using https://nikitahl.github.io/svg-circle-progress-generator/
export const StatusBarMobile = () => {
  const classes = useStyles()
  const { step: currentStep = 0 } = useStepsState()
  const { t } = useTranslation()
  const isCityVariant = useIsCityVariant()
  const isAllClinicsVariant = useIsAllClinicsVariant()

  return (
    <div className={classes.root}>
      <div className={classes.stepName}>
        {t(getStepNameFromNumber(currentStep, isCityVariant, isAllClinicsVariant))}
      </div>
    </div>
  )
}
